/* =====================================================
   Signature Notes — interactions
   - IntersectionObserver stagger reveal
   - Pointer-tracking glow per card (desktop, fine pointer)
   - Respects prefers-reduced-motion
   ===================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.snInit === '1') return;
    section.dataset.snInit = '1';

    var reveals = section.querySelectorAll('[data-sn-reveal]');
    var cards = section.querySelectorAll('[data-sn-card]');

    /* ---------- Reveal ---------- */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-visible'); });
      cards.forEach(function (el) { el.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
      cards.forEach(function (el) { io.observe(el); });
    }

    /* ---------- Pointer glow (desktop only) ---------- */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (fine && !reduceMotion) {
      cards.forEach(function (card) {
        var inner = card.querySelector('.sn-card__inner');
        var glow = card.querySelector('.sn-card__glow');
        if (!inner || !glow) return;

        var rafId = 0;
        var px = 50, py = 50;
        function apply() {
          rafId = 0;
          glow.style.setProperty('--sn-mx', px + '%');
          glow.style.setProperty('--sn-my', py + '%');
        }
        card.addEventListener('pointermove', function (e) {
          var rect = inner.getBoundingClientRect();
          px = ((e.clientX - rect.left) / rect.width) * 100;
          py = ((e.clientY - rect.top) / rect.height) * 100;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
        card.addEventListener('pointerleave', function () {
          px = 50; py = 50;
          if (!rafId) rafId = requestAnimationFrame(apply);
        }, { passive: true });
      });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-signature-notes]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
